module.exports = __webpack_public_path__ + "static/img/startupDailyColor.a169cea3.png";